var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0EFEB"
    },
    d: "M512,256c0,48.797-13.657,94.407-37.355,133.214c-14.952,24.503-33.917,46.289-55.965,64.449 c-2.288,1.881-4.608,3.73-6.959,5.528c-18.871,14.493-39.811,26.405-62.307,35.234C320.481,505.772,288.966,512,256,512 s-64.47-6.228-93.414-17.575c-22.497-8.819-43.436-20.741-62.307-35.223c-25.036-19.205-46.414-42.945-62.924-69.977 C13.657,350.417,0,304.797,0,256C0,114.615,114.615,0,256,0c61.785,0,118.45,21.88,162.68,58.337C475.669,105.284,512,176.4,512,256 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F36306"
    },
    d: "M349.414,244.266v250.159C320.481,505.772,288.966,512,256,512s-64.47-6.228-93.414-17.575V244.266 l60.813-35.119v250.044L256,478.02l32.601-18.829V209.147L349.414,244.266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F36306"
    },
    d: "M474.645,171.959v217.255c-14.952,24.503-33.917,46.289-55.965,64.449 c-2.288,1.881-4.608,3.73-6.959,5.528V208.29L256,118.387L100.279,208.29v250.911c-25.036-19.205-46.414-42.945-62.924-69.977 V171.959L256,45.746L474.645,171.959z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagento);
export default __webpack_public_path__ + "static/media/magento.b5ea88377c64084e7681a96a642f033f.svg";
export { ForwardRef as ReactComponent };